import { CliqDbAction } from "./types";

export const sliders = [
    {
        image: 'assets/images/login-img1.png',
        textKey: 'SLIDER.TEXT1',
    },
    {
        image: 'assets/images/login-img2.png',
        textKey: 'SLIDER.TEXT2',
    },
    {
        image: 'assets/images/login-img3.png',
        textKey: 'SLIDER.TEXT3',
    }
];

export const routeTitleMap: Record<string, string> = {
  'accounts': 'HEADER_TITLES.ACCOUNTS',
  'activity-status': 'HEADER_TITLES.ACTIVITY_STATUS',
  'transactions': 'HEADER_TITLES.TRANSACTIONS',
  'user-management': 'HEADER_TITLES.USER_MANAGEMENT',
  'change-password': 'HEADER_TITLES.CHANGE_PASSWORD',
  'cards': 'HEADER_TITLES.CARDS',
  'forgot-password': 'HEADER_TITLES.FORGOT_PASSWORD',
  'settings': 'HEADER_TITLES.SETTINGS',
  'help-center': 'HEADER_TITLES.HELP_CENTER',
  'onboarding': 'HEADER_TITLES.ONBOARDING',
  'bill-payments': 'HEADER_TITLES.BILL_PAYMENTS',
  'cash-push': 'HEADER_TITLES.CASH_PUSH',
  'cash-pull': 'HEADER_TITLES.CASH_PULL',
  'cliq-beneficiaries': 'HEADER_TITLES.CLIQ_BENEFICIARIES',
  'manage-cliq-alias': 'HEADER_TITLES.MANAGE_CLIQ_ALIAS',
  'create-cliq-alias': 'HEADER_TITLES.CREATE_CLIQ_ALIAS',
  'cliq-pay-confirmation': 'HEADER_TITLES.CONFIRMATION',
  'cliq-pay': 'HEADER_TITLES.CLIQ_PAY',
  'payment-request': 'HEADER_TITLES.PAYMENT_REQUEST'
};

export const allQuickActions = [
  {
    type: 'selected-default-actions',
    label: 'QUICK_ACTIONS.QUICK_ACTIONS_LABEL',
    actions: [
      { id: 'cliq', actionLogo: 'assets/icons/CliQ.svg', title: 'CliQ' },
      { id: 'efawateer', actionLogo: 'assets/icons/eFawateercom.svg', title: 'eFawateercom' },
      { id: 'cash-pull', actionLogo: 'assets/icons/cash-pull.svg', title: 'Cash pull' },
      { id: 'cash-push', actionLogo: 'assets/icons/cash-push.svg', title: 'Cash push' }
    ]
  },

  {
    type: 'money-out',
    label: 'QUICK_ACTIONS.MONEY_OUT',
    actions: [
      { id: 'cash-push', actionLogo: 'assets/icons/cash-push.svg', title: 'Cash push' }
    ]
  },

  {
    type: 'money-in',
    label: 'QUICK_ACTIONS.MONEY_IN',
    actions: [
      { id: 'claim-rem', actionLogo: 'assets/icons/claim-remittance.svg', title: 'Claim remittance' },
      { id: 'cardless', actionLogo: 'assets/icons/cardless-deposit.svg', title: 'Cardless deposit' },
      { id: 'cash-pull', actionLogo: 'assets/icons/cash-pull.svg', title: 'Cash pull' }
    ]
  },

  {
    type: 'other-services',
    label: 'QUICK_ACTIONS.OTHER_SERVICES',
    actions: [
      { id: 'cliq', actionLogo: 'assets/icons/CliQ.svg', title: 'CliQ' },
      { id: 'evoucher', actionLogo: 'assets/icons/e-Voucher.svg', title: 'E-voucher' },
      { id: 'efawateer', actionLogo: 'assets/icons/eFawateercom.svg', title: 'eFawateercom' },
      { id: 'benef', actionLogo: 'assets/icons/manage-beneficiary.svg', title: 'Manage beneficiary' },
      { id: 'help', actionLogo: 'assets/icons/help-support.svg', title: 'Help & support' }
    ]
  }
];

export const cliqDbActions: CliqDbAction[]= [
  {
    iconPath: "assets/icons/cliq-pay.svg",
    label: "CliQ Pay",
    description: "Send & Request money via CliQ",
    id: "cliqPay"
  },
    {
    iconPath: "assets/icons/cliq-beneficiary.svg",
    label: "CliQ Beneficiaries",
    description: "Manage your beneficiaries",
    id: "cliqBeneficiaries"
  },
    {
    iconPath: "assets/icons/cliq-manage-id.svg",
    label: "Manage CliQ ID",
    description: "Manage your CliQ ID",
    id: "cliqManageId"
  }
]

export const KEY_PERSONNEL_DETAILS_FORM_KEYS = {
    INDIVIDUAL_OWNERS: 'individual-owners',
    CORPORATE_OWNERS: 'corporate-owners',
    EXECUTIVE_MANAGEMENT: 'executive-management',
    AUTHORIZED_SIGNATORY: 'authorized-signatory',
} as const;

export const ENGLISH_REGEX = /^[A-Za-z ]+$/;
export const ARABIC_REGEX = /^[\u0600-\u06FF\u0750-\u077F\u08A0-\u08FF\uFB50-\uFDFF\uFE70-\uFEFF ]+$/;
